import * as React from 'react'
import { cn } from '../../lib/utils'

const Input = React.forwardRef<React.ComponentRef<'input'>, React.ComponentPropsWithoutRef<'input'>>(
  ({ className, type, ...props }, ref) => (
    <input
      type={type}
      className={cn(
        'flex h-10 w-full rounded-[var(--radius-input)] border border-border bg-background px-3 py-2 text-sm text-foreground ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-foreground-muted focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50',
        className
      )}
      ref={ref}
      data-figma-component="Input"
      data-figma-type={type || 'text'}
      {...props}
    />
  )
)
Input.displayName = 'Input'

export { Input }
